import { AppState } from '../reducers'
import { IMessage } from '../reducers/message'

export const getMessage = (state: AppState): IMessage => state.message
